// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Percent24CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Percent24Circle: FC<Percent24CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="32"
            height="32"
        >
            <path d="M12.563 12.563A1.446 1.446 0 0 1 11.5 13c-.417 0-.77-.146-1.063-.438A1.446 1.446 0 0 1 10 11.5c0-.417.146-.77.438-1.063A1.446 1.446 0 0 1 11.5 10c.417 0 .77.146 1.063.438.291.291.437.645.437 1.062 0 .417-.146.77-.438 1.063ZM21.563 21.563A1.446 1.446 0 0 1 20.5 22c-.417 0-.77-.146-1.063-.438A1.446 1.446 0 0 1 19 20.5c0-.417.146-.77.438-1.063A1.446 1.446 0 0 1 20.5 19c.417 0 .77.146 1.063.438.291.291.437.645.437 1.062 0 .417-.146.77-.438 1.063Z" />
            <path
                d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16ZM9.025 13.975A3.372 3.372 0 0 0 11.5 15c.967 0 1.792-.342 2.475-1.025A3.372 3.372 0 0 0 15 11.5c0-.967-.342-1.792-1.025-2.475A3.372 3.372 0 0 0 11.5 8c-.967 0-1.792.342-2.475 1.025A3.372 3.372 0 0 0 8 11.5c0 .967.342 1.792 1.025 2.475Zm9 9A3.372 3.372 0 0 0 20.5 24c.967 0 1.792-.342 2.475-1.025A3.372 3.372 0 0 0 24 20.5c0-.967-.342-1.792-1.025-2.475A3.372 3.372 0 0 0 20.5 17c-.967 0-1.792.342-2.475 1.025A3.372 3.372 0 0 0 17 20.5c0 .967.342 1.792 1.025 2.475ZM8 22.6 9.4 24 24 9.4 22.6 8 8 22.6Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Percent24Circle;
